var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { Row } from "react-bootstrap";
import InputField from "@frameworks/web/components/generic/inputField";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
var AddRequest = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = __read(useState([]), 2), segmentlist = _l[0], setSegmentList = _l[1];
    var _m = __read(React.useState(), 2), SearchlsinState = _m[0], setSearchlsinState = _m[1];
    var _calendar = useRef(null);
    var _o = __read(useState(false), 2), searchDropdown = _o[0], setSearchDropdown = _o[1];
    var _p = __read(useState(new Date()), 2), startDate = _p[0], setStartDate = _p[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getSegmentData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, segment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients.getExceptionSegment({
                        Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                    })];
                case 1:
                    resp = _a.sent();
                    segment = resp.map(function (item) {
                        return { display: item.value, value: item.id };
                    });
                    setSegmentList(segment);
                    return [2 /*return*/];
            }
        });
    }); };
    var getExceptionisinData = function (enteredTxt) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        searchText: enteredTxt,
                    };
                    return [4 /*yield*/, di.clients
                            .getExceptionlsin(payload)
                            .then(function (responseData) {
                            setSearchlsinState(responseData);
                        })
                            .catch(function (error) {
                            console.log("ISIN Error", error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        getSegmentData();
    }, [selectedAcount]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "addrequest-body commonscroll-new" },
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "ISIN"),
                React.createElement("div", { className: "position-relative p-0" },
                    React.createElement(InputField, { type: "text", id: "isin", name: "isin", required: true, autoComplete: "off", placeholderClassName: "", onChangeEvent: function (e) {
                            getExceptionisinData(e.target.value);
                            setSearchDropdown(true);
                        }, defaultValue: (_b = (_a = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _a === void 0 ? void 0 : _a.selectedsinState) === null || _b === void 0 ? void 0 : _b.v_isin }),
                    searchDropdown === true && (React.createElement("div", { className: "position-absolute w-100 bg_white search-data-table p-0" },
                        React.createElement("table", null,
                            React.createElement("tbody", null, SearchlsinState &&
                                SearchlsinState.length > 0 &&
                                SearchlsinState.map(function (items) {
                                    return (React.createElement("tr", { className: "client-search-row hand_cursor", onClick: function () {
                                            props === null || props === void 0 ? void 0 : props.setAddRequestData(__assign(__assign({}, props === null || props === void 0 ? void 0 : props.addRequestData), { selectedsinState: items }));
                                            setSearchDropdown(false);
                                        } },
                                        React.createElement("td", { className: "DMSans_16_500 txt_blackOne1 p-2" }, items.v_isin),
                                        React.createElement("td", { className: "DMSanM_14_500 txt_primaryGrey p-2" }, items.v_scripcode),
                                        React.createElement("td", { className: "DMSanM_14_500 txt_primaryGrey p-2" }, items.v_scrip_name)));
                                }))))))),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Scrip Code"),
                React.createElement(InputField, { type: "text", id: "scripcode", name: "scripcode", required: true, autoComplete: "off", placeholderClassName: "", defaultValue: (_d = (_c = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _c === void 0 ? void 0 : _c.selectedsinState) === null || _d === void 0 ? void 0 : _d.v_scripcode })),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Scrip Name"),
                React.createElement(InputField, { type: "text", id: "scripname", name: "scripname", required: true, autoComplete: "off", placeholderClassName: "", defaultValue: (_f = (_e = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _e === void 0 ? void 0 : _e.selectedsinState) === null || _f === void 0 ? void 0 : _f.v_scrip_name })),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Expiry Date:"),
                React.createElement("div", { className: "col leadpage-selectdropdown leadpage-calendar pdl-0" },
                    React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate leadpage-calendar-input" },
                        React.createElement(DatePicker, { ref: _calendar, selected: startDate, onChange: function (date) { return setStartDate(date); }, showYearDropdown: true, showMonthDropdown: true, dateFormat: "d-MMM-yy", placeholderText: "dd-mm-yy" }),
                        React.createElement("span", { className: "input-group-text pb-3 pt-2" },
                            React.createElement("i", { className: "edel-icon-calendar-report", onClick: function () { return _calendar.current.setOpen(true); } }))))),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Upper Cap"),
                React.createElement(InputField, { type: "text", id: "uppercap", name: "uppercap", required: true, autoComplete: "off", placeholderClassName: "", defaultValue: (_g = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _g === void 0 ? void 0 : _g.uppercap, onChangeEvent: function (e) {
                        return props === null || props === void 0 ? void 0 : props.setAddRequestData(__assign(__assign({}, props === null || props === void 0 ? void 0 : props.addRequestData), { uppercap: e.target.value }));
                    } })),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Hair Cut"),
                React.createElement(InputField, { type: "text", id: "haircut", name: "haircut", required: true, autoComplete: "off", placeholderClassName: "", defaultValue: (_h = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _h === void 0 ? void 0 : _h.haircut, onChangeEvent: function (e) {
                        return props === null || props === void 0 ? void 0 : props.setAddRequestData(__assign(__assign({}, props === null || props === void 0 ? void 0 : props.addRequestData), { haircut: e.target.value }));
                    } })),
            React.createElement(Row, { className: "m-0 p-0 request-row leadpage-selectdropdown" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Segment"),
                React.createElement(SelectDropdown, { placeholder: "Select Segment Type", id: "Segment_dropdown", name: "Segment_dropdown", selected: true, dropdownOptions: segmentlist, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", value: (_j = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _j === void 0 ? void 0 : _j.selectSegment, onChangeEvent: function (e) {
                        return props === null || props === void 0 ? void 0 : props.setAddRequestData(__assign(__assign({}, props === null || props === void 0 ? void 0 : props.addRequestData), { selectSegment: e.target.id }));
                    } })),
            React.createElement(Row, { className: "m-0 p-0 request-row" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Remarks"),
                React.createElement(InputField, { type: "text", id: "remarks", name: "remarks", required: true, autoComplete: "off", placeholderClassName: "", value: (_k = props === null || props === void 0 ? void 0 : props.addRequestData) === null || _k === void 0 ? void 0 : _k.remarks, onChangeEvent: function (e) {
                        return props === null || props === void 0 ? void 0 : props.setAddRequestData(__assign(__assign({}, props === null || props === void 0 ? void 0 : props.addRequestData), { remarks: e.target.value }));
                    } })))));
};
export default AddRequest;
